import React, { useEffect, useRef, useState } from 'react';
import { ChevronDown, Check, Truck } from 'lucide-react';
import { shippingAPI } from '../services/api';
import { customerCountry, useShippingSummary, fmtEuro } from '../services/shippingInfo';
import { useT } from '../services/i18n';

const Flag = ({ code, size = 18 }) => (
  <img src={`https://flagcdn.com/w40/${code.toLowerCase()}.png`} alt="" width={size} height={Math.round(size * 0.75)} className="rounded-[2px] object-cover" />
);

let countriesCache = null;

// Header delivery-country selector — drives the free-shipping threshold shown across the site
const CountrySwitcher = ({ variant = 'dark' }) => {
  const { t } = useT();
  const ship = useShippingSummary();
  const [open, setOpen] = useState(false);
  const [countries, setCountries] = useState(countriesCache || []);
  const ref = useRef(null);
  useEffect(() => { const h = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); }; document.addEventListener('mousedown', h); return () => document.removeEventListener('mousedown', h); }, []);
  useEffect(() => { if (!countriesCache) shippingAPI.countries().then(list => { countriesCache = list; setCountries(list); }).catch(() => {}); }, []);
  const current = ship.country || 'FR';
  const choose = (code) => { customerCountry.set(code); setOpen(false); };
  const styles = {
    dark: ['relative hidden md:block', 'text-white hover:text-orange-400'],
    light: ['relative w-full', 'text-gray-800 hover:text-orange-600 border border-gray-300 rounded-lg px-3 py-2'],
  };
  const [wrap, btn] = styles[variant] || styles.dark;
  return (
    <div className={wrap} ref={ref} data-testid="country-switcher">
      <button type="button" onClick={() => setOpen(o => !o)} className={`inline-flex items-center gap-1.5 text-sm transition-colors ${btn}`} title={t('header.deliveryCountry')} aria-label={t('header.deliveryCountry')} data-testid="country-switcher-button">
        <Truck size={14} className="opacity-70" /><Flag code={current} /><span className="uppercase font-medium" data-testid="country-switcher-current">{current}</span><ChevronDown size={14} className="opacity-70" />
      </button>
      {open && (
        <div className="absolute right-0 z-[60] mt-2 w-64 rounded-md border border-gray-200 bg-white shadow-lg py-1 text-sm text-gray-800" data-testid="country-switcher-menu">
          <p className="px-3 py-1.5 text-[11px] font-semibold uppercase tracking-wide text-gray-400">{t('header.deliveryCountry')}</p>
          {countries.map(c => (
            <button key={c.code} type="button" onClick={() => choose(c.code)} className={`flex w-full items-center gap-2.5 px-3 py-2 text-left hover:bg-orange-50 ${c.code === current ? 'font-semibold text-orange-600' : ''}`} data-testid={`country-option-${c.code}`}>
              <Flag code={c.code} size={20} />
              <span className="flex-1 truncate">{c.name}</span>
              <span className="text-[11px] text-gray-400 font-normal whitespace-nowrap">{c.free_from != null ? t('header.freeFromShort', { n: fmtEuro(c.free_from).replace(' €', '') }) : (c.price != null ? fmtEuro(c.price) : '')}</span>
              {c.code === current && <Check size={14} />}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default CountrySwitcher;
